import axios from 'axios';

export default class InstaFeed {
  constructor(id) {
    this.id = id;
    this.getUrl = `https://api.curator.io/v1/feeds/${this.id}`;
    this.config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
  }

  async get() {
    try {
      const res = await axios.get(this.getUrl, this.config);
      return res.data;
    } catch (err) {
      return console.log(err);
    }
  }
}
